import { useEffect, useRef } from "react";

// typed-js
import Typed from "typed.js";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import { Link } from "react-router-dom";

function ProjectHeader() {
  // Setting up typedJS
  useEffect(() => {
    
  }, []);

  return (
      <MKBox
        display="flex"
        alignItems="center"
        minHeight="50vh"
        sx={{
          backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
            `linear-gradient(${rgba(gradients.dark.main, 0.6)},${rgba(gradients.dark.state, 0.6)}),
          url("https://raw.githubusercontent.com/creativetimofficial/public-assets/master/material-kit-pro-react/material-design-background.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            mx="auto"
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {"Projects"}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
  );
}

export default ProjectHeader;
